// import ChatOutlinedIcon from '@mui/icons-material/ChatOutlined';
// import SmartphoneOutlinedIcon from '@mui/icons-material/SmartphoneOutlined';
import LightbulbOutlinedIcon from "@mui/icons-material/LightbulbOutlined";
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';


export interface ChatSuggestion {
  text: string;
  icon: any;
}

// export const CHAT_SUGGESTIONS: ChatSuggestion[] = [
//   {
//     text: 'Suggest a cross-sell message for someone who bought a smartphone.',
//     icon: SmartphoneOutlinedIcon
//   },
//   {
//     text: "Create a cohort to target customers who haven't purchased in the last 6 months.",
//     icon: ChatOutlinedIcon
//   },
// ];


export const CHAT_SUGGESTIONS_MODE_CONFIG = {
    normal: {
        label: "Normal",
        welcomeTitle: "Some Ideas to get Started",
        icon: LightbulbOutlinedIcon,
        suggestions: [
            { text: 'Suggest a cross-sell message for someone who bought a smartphone.' },
            { text: "Create a cohort to target customers who haven't purchased in the last 6 months." },
        ]
    },
    interactive: {
        label: "Interactive",
        welcomeTitle: "What would like to Build today ?",
        icon: AutoFixHighIcon,
        suggestions: [
            { text: 'Create an onboarding Journey' },
            { text: 'Built an multi variant campaign' },
        ]
    }
};

export const DEFAULT_PLACEHOLDERS = {
  INITIAL: 'How can I help you today?',
  FOLLOWUP: 'What else can I help you with?',
} as const;